<template>
  <div class="testList">
    <div class="add">
      <!-- <el-button v-if="item.isStop" disabled type="info" style="width:150px;height:40px" >报 名 </el-button>
      <el-button v-else type="danger" style="width:150px;height:40px" @click="signUp(item)">报 名 </el-button> -->
      <el-button type="primary" size="medium" @click="addClass" :disabled="false">新增测试班</el-button>
    </div>
    <el-table :data="tableData" style="width: 100%" :row-class-name="tableRowClassName">
      <el-table-column label="序号" type="index" :index="getIndex" width="60px" align="center"></el-table-column>
      <el-table-column prop="test_class_title" label="测试名称" align="center">
        <template slot-scope="scope">
          <span style="color: #0000FF; cursor:pointer" @click="handleClickOpen(scope.row)" type="text"
                size="small">{{ scope.row.test_class_title }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="test_grade" label="测试等级" align="center" width="80px">
        <template slot-scope="scope">
          <!-- <span v-for="(item,index) in scope.row.test_grade" :key="index">{{item.grade}}、</span> -->
          <span>{{ scope.row.testGradeTemp }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="registration_start_time" label="报名时间" align="center" width="155px">
        <template slot-scope="scope">
          {{
            scope.row.registration_start_time|dateformat('YYYY-MM-DD HH:mm')
          }} 至 {{ scope.row.registration_end_time|dateformat('YYYY-MM-DD HH:mm') }}
        </template>
      </el-table-column>
      <el-table-column prop="test_start_time" label="测试时间" align="center" width="155px">
        <template slot-scope="scope">
          {{
            scope.row.test_start_time|dateformat('YYYY-MM-DD HH:mm')
          }} 至 {{ scope.row.test_end_time|dateformat('YYYY-MM-DD HH:mm') }}
        </template>
      </el-table-column>
      <el-table-column prop="test_detail_addr" label="测试地址" align="center" width="170px">
        <template slot-scope="scope">
          <span>{{
              scope.row.province_name == scope.row.city_name ? scope.row.province_name : scope.row.province_name + scope.row.city_name
            }}{{ scope.row.district_name }}{{ scope.row.test_detail_addr }}
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="test_num" label="名额" align="center" fixed="right"></el-table-column>
      <!-- 显示是否发布 -->
      <el-table-column prop="application_status" label="审核结果" align="center" fixed="right"></el-table-column>
      <el-table-column prop="approval_comments" label="审核意见" align="center" fixed="right"></el-table-column>
      <el-table-column prop="approval_comments" label="退费状态" align="center" fixed="right">
        <template slot-scope="scope">
          {{
            scope.row.refund_status === 0 ? '未退费' : scope.row.refund_status === 1 ? '退费中' : scope.row.refund_status === 2 ? '退费成功' : '退费失败'
          }}
        </template>
      </el-table-column>
      <el-table-column prop="6" label="操作" align="center" fixed="right">
        <template slot-scope="scope">
          <el-button @click="handleClick(scope.row)" type="text" size="small"
                     v-if="scope.row.application_status != '未审批'">查看录入
          </el-button>
          <el-button @click="handleAddRefund(scope.row)" type="text" size="small"
                     v-if="scope.row.application_status == '中羽协审核通过' && (scope.row.refund_status === 0 || scope.row.refund_status === 1)">
            {{ scope.row.refund_status === 0 ? '退费' : '取消退费' }}
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination" style="margin-top:20px;text-align:center;">
      <el-pagination
          background
          layout="prev, pager, next"
          @current-change="handleCurrentChange"
          :page-size="paging.limit"
          v-if="totalCount>8"
          :total="totalCount"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import {GetTestApplyList, saveRefund} from "@/api/admin/test.js";

export default {
  data() {
    return {
      tableData: [],
      paging: {
        limit: 8,
        page: 1
      },
      totalCount: 0
    };
  },
  created() {
    this.getList();
  },
  methods: {
    tableRowClassName({row, rowIndex}) {
      if (row.refund_status === 1) {
        return 'warning-row';
      }
      return '';
    },
    // 表格索引
    getIndex(index) {
      let curpage = this.paging.page; //当前页码
      let limitpage = this.paging.limit; //每页条数
      return index + 1 + (curpage - 1) * limitpage;
    },
    getList() {

      GetTestApplyList(Object.assign(this.paging)).then(data => {
        var list = data.data.result;
        if (list) {
          this.tableData = list.items;

          this.totalCount = list.totalCount;
          this.doList();
        }
      });
    },
    formatDate(row) {
      let moment = require("moment");
      return moment(row.creationTime).format("YYYY-MM-DD HH:mm:ss");
    },
    handleClickOpen(row) {
      this.$router.push({
        path: "/personal/addClassApplicationView",
        query: {
          id: row.id
        }
      });
    },
    handleClick(row) {
      if (row.application_status == '中羽协审核通过') {
        this.$router.push({
          path: "/personal/testList/viewEntry",
          query: {
            id: row.id,
            application_status: row.application_status
          }
        });
      } else {
        alert("还未通过审核，请通过审核后操作");
      }

    },
    //新增测试班  /personal/addClassApplicationView
    addClass() {
      this.$router.push({path: "/personal/addClassApplication"});
    },
    /*
    2020年10月26日 10:49:54
    XXL
    改变列表数据格式
    */
    doList() {
      for (var i = 0; i < this.tableData.length; i++) {
        this.tableData[i].aaaa = "dddd";
        var tempGrade = "";
        for (var j = 0; j < this.tableData[i].test_grade.length; j++) {
          tempGrade = tempGrade + "、" + this.tableData[i].test_grade[j].grade;
        }
        this.tableData[i].testGradeTemp = tempGrade.substr(1, tempGrade.length);

        if (this.tableData[i].application_status == '申请中') {
          this.tableData[i].application_status = "省羽协审核中";
        } else if (this.tableData[i].application_status == '省羽协审核通过') {
          this.tableData[i].application_status = "中国羽协审核中";
        }
      }
    },
    // 分页
    handleCurrentChange(cpage) {
      this.paging.page = cpage;
      GetTestApplyList(Object.assign(this.paging)).then(data => {
        var list = data.data.result;
        if (list) {
          this.tableData = list.items;
          this.doList();
        }
      });
    },
    handleAddRefund(row) {
      const msg = row.refund_status === 0 ? '退费' : '取消退费'
      const status = row.refund_status === 0 ? 1 : 0
      let data = {test_class_id: row.id, status: status}
      this.$confirm('是否确认' + msg + '?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        saveRefund(data).then(res => {
          this.$message({
            type: 'success',
            message: '提交成功!'
          });
          this.getList();
        })
      }).catch(() => {
      });
    },
  }
};
</script>

<style lang="less" scoped>
.testList {
  .add {
    margin-bottom: 10px;
  }
}

.el-table .warning-row {
  background: oldlace;
}
</style>
